import generateBasicEntityActions from './generateBasicEntityActions';

const professionActions = generateBasicEntityActions('professions');

export default professionActions;
